// Translations for the shared app shell (Layout.js): header, sidebar nav,
// bottom nav, user/notification dropdowns.
const shellDict = [
  { en: "Dashboard", sw: "Dashibodi" },
  { en: "Members", sw: "Wanachama" },
  { en: "Branches", sw: "Matawi" },
  { en: "Contributions", sw: "Michango" },
  { en: "Accounting", sw: "Uhasibu" },
  { en: "Loans", sw: "Mikopo" },
  { en: "Messages", sw: "Ujumbe" },
  { en: "Meetings", sw: "Mikutano" },
  { en: "Elections", sw: "Uchaguzi" },
  { en: "ID Cards", sw: "Kadi za Utambulisho" },
  { en: "Card Templates", sw: "Violezo vya Kadi" },
  { en: "Recruitment", sw: "Ajira" },
  { en: "Reports", sw: "Ripoti" },
  { en: "Users", sw: "Watumiaji" },

  { en: "Accounting Overview", sw: "Muhtasari wa Uhasibu" },
  { en: "Accounts Receivable", sw: "Madeni ya Wateja" },
  { en: "Customers", sw: "Wateja" },
  { en: "Customer Invoices", sw: "Ankara za Wateja" },
  { en: "Receipts", sw: "Risiti" },
  { en: "Accounts Payable", sw: "Madeni ya Wauzaji" },
  { en: "Suppliers", sw: "Wauzaji" },
  { en: "Supplier Invoices", sw: "Ankara za Wauzaji" },
  { en: "Payments", sw: "Malipo" },
  { en: "Banking & Cash", sw: "Benki na Fedha Taslimu" },
  { en: "Bank Accounts", sw: "Akaunti za Benki" },
  { en: "Cash / Bank Transfers", sw: "Uhamisho wa Fedha/Benki" },
  { en: "Cash / Bank Book", sw: "Kitabu cha Fedha/Benki" },
  { en: "Statement Import", sw: "Uingizaji wa Taarifa ya Benki" },
  { en: "Reconciliation", sw: "Upatanisho wa Akaunti" },
  { en: "General Ledger", sw: "Daftari Kuu" },
  { en: "Budgets", sw: "Bajeti" },
  { en: "Financial Reports", sw: "Ripoti za Fedha" },
  { en: "Accounting Settings", sw: "Mipangilio ya Uhasibu" },

  { en: "My Profile", sw: "Wasifu Wangu" },
  { en: "My ID", sw: "Kitambulisho Changu" },
  { en: "Library", sw: "Maktaba" },
  { en: "Support", sw: "Msaada" },
  { en: "Calendar", sw: "Kalenda" },
  { en: "Trainings", sw: "Mafunzo" },
  { en: "Cases", sw: "Kesi" },

  { en: "Search...", sw: "Tafuta..." },
  { en: "Notifications", sw: "Arifa" },
  { en: "new", sw: "mpya" },
  { en: "No notifications", sw: "Hakuna arifa" },
  { en: "Notification", sw: "Arifa" },
  { en: "User", sw: "Mtumiaji" },
  { en: "Settings", sw: "Mipangilio" },
  { en: "Logout", sw: "Toka" },
  { en: "MAIN MENU", sw: "MENYU KUU" },
  { en: "Announcements", sw: "Matangazo" },
];

export default shellDict;
